import { fetcher } from "../index"
import {
  getResolvedSpaceId,
  type ResolveSpaceResponse,
} from "./resolveSpaceResponse"
import { createResolveSpaceForReturnUrlPath } from "./resolveSpaceForReturnUrlPath"

export const resolveSpaceIdForReturnUrl = async (
  returnUrl: string,
): Promise<string | null> => {
  const response = (await fetcher(
    createResolveSpaceForReturnUrlPath(returnUrl),
  )) as ResolveSpaceResponse

  return getResolvedSpaceId(response)
}
